/** 입력창을 처음 열면 차례로 짚는 곳 — 입력칸 → 자료 탭 → 조건 칩(Figma 「AI 원샷 온보딩」 1-1~1-3). */
export const AI_GENERATE_DOCK_ONBOARDING_STEPS = [
  'input',
  'source',
  'conditions',
] as const;

export type AiGenerateDockOnboardingStep =
  (typeof AI_GENERATE_DOCK_ONBOARDING_STEPS)[number];

/** 브라우저별로 한 번만 — 문구·단계가 크게 바뀌면 버전을 올려 다시 보여 준다. */
export const AI_GENERATE_DOCK_ONBOARDING_STORAGE_KEY =
  'quiz.build.aiGenerateOnboarding.v1';

/** 입력창 여는 모션(250ms, AiGenerateDockUI 의 OPEN_MOTION_CLASS)이 끝난 뒤 띄운다 — 움직이는 동안 재면 자리가 어긋난다. */
export const AI_GENERATE_DOCK_ONBOARDING_START_DELAY_MS = 250;

/** 코치마크 카드와 강조 대상을 잇는 선 — Figma `.Onboarding/연결선` 10×48. */
export const AI_GENERATE_DOCK_ONBOARDING_CONNECTOR = {
  width: 10,
  height: 48,
} as const;

/**
 * 강조 구멍을 대상에서 얼마나 넓힐지(px, 음수는 안으로). Figma 딤 구멍과 대상의 차이를 그대로 옮겼다 —
 * 입력칸은 입력창 윗부분에서 좌우·위 8, 아래 4 만큼 안쪽, 탭·조건 칩은 사방 4 만큼 바깥.
 */
export const AI_GENERATE_DOCK_ONBOARDING_HOLE_OUTSET: Record<
  AiGenerateDockOnboardingStep,
  { top: number; right: number; bottom: number; left: number }
> = {
  input: { top: -8, right: -8, bottom: -4, left: -8 },
  source: { top: 4, right: 4, bottom: 4, left: 4 },
  conditions: { top: 4, right: 4, bottom: 4, left: 4 },
};

/** 연결선 끝 점은 구멍 위 가장자리에서 이만큼 안으로 들어가 닿는다(Figma 1-1~1-3 공통). */
export const AI_GENERATE_DOCK_ONBOARDING_CONNECTOR_OVERLAP_PX = 4;

/** 카드가 화면 가장자리에 붙지 않게 남기는 여백. */
export const AI_GENERATE_DOCK_ONBOARDING_EDGE_PX = 16;
